var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props),
    React.createElement(
      "title",
      null,
      "AccountsNotStarted"
    ),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-light-gray"] || "oc-icon-light-gray"), d: "M10.05 0a10 10 0 1 1-10 10 10 10 0 0 1 10-10z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/NotStarted.svg